module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_aktuelle_Monatsangebote.b24bc7bf.png";